import React, { useEffect, useState } from 'react';
// Libraries
import { useParams } from 'react-router-dom';
// Components
import Lottie from 'react-lottie'
import Loading from '~/components/loading';
import Button from '~/components/button';
import Title from '~/components/typography/title'
import Text from '~/components/typography/text'
//
import List from './components/List';
// Utils
import SocialMeAPI from '~/utils/SocialMeAPI';
import animationData from '~/assets/images/lotties/earth.json'

export default function FilesList({ document }) {
  const { institutionId, organizationUnitId } = useParams();
  const [treeData, setTreeData] = useState();
  const [loadingContent, setLoadingContent] = useState(true);
  const [print, setPrint] = useState(false)

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }

  useEffect(() => {
    async function GetAttachments() {
      const params = {
        operation: ['SIGAM', 'Documents', 'Attachments', 'Get'],
        urlParams: {
          institutionId,
          organizationUnitId,
          documentId: document.id,
        },
        data: {
          pagination: {
            limit: 0,
          },
        },
      };
      const response = await SocialMeAPI(params);
      // console.log(response)
      if (response.success) {
        const tree = [];
        const father = {
          ...document,
          title: document.name,
          key: '1',
          type: 'document',
          data: document,
          children: []
        }
        const array = response.body.attachments.elements
        for (let i = 0; i < array.length; i++) {
          const newItem = {
            ...array[i],
            title: array[i].name,
            key: `1-${i + 1}`,
            type: 'attachment',
            data: array[i],
          };
          father.children.push(newItem)
        }
        tree.push(father);
        // console.log(tree)
        setTreeData(tree);
      }
      setLoadingContent(false);
    }
    GetAttachments();
  }, [institutionId, organizationUnitId, process])

  return (
    <div>
      {loadingContent ?
        <Loading />
        :
        print ?
          <List document={document} treeData={treeData} />
          :
          <div style={{ display: 'flex', gap: '10px' }}>
            <div>
              <Lottie options={defaultOptions} height={120} width={120} />
            </div>
            <div style={{ display: "flex", flexDirection: 'column', justifyContent:'space-between' }}>
              <Title level={4} style={{ margin: 0 }}>Digitalização é uma das principais medidas para a proteção do meio ambiente</Title>
              <Text type="success">Menos papel e mais árvores</Text>
              <Button onClick={() => setPrint(true)} type="primary">Preparar impressão</Button>
            </div>
          </div>
      }
    </div>
  )
}